import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import publicAxios from "../utils/publicAxios";
import { useNavigate } from "react-router-dom";
import { showToast } from "../utils/utils";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaEye, FaEyeSlash, FaCheck, FaInfoCircle } from "react-icons/fa";
import "./../assets/scss/login.scss";
import "./../assets/scss/common.scss";

import Footerweb from "../components/layout/footer/Footerweb";
import Headerweb from "../components/layout/header/Headerweb";
import {
  aboutSignUpContent,
  changeUserPass,
  Inputfieldvalidation,
  login,
  passwordtext,
  profiletexts,
  referencePromoCode,
  signup,
  metaPixel
} from "../locales/en";
import {
  COUNTRY_CODE_AU_SMALL,
  DIGIT_REGEX,
  EMAIL_REGEX,
  SPECIAL_CHAR_REGEX,
  NUMBER_REGEX,
  PASSWORD_VALIDATION_REGEX,
  showToastType,
  UPPERCASE_REGEX,
  TRACK
} from "../utils/constants/appConstants";

const ConferenceSignUp = () => {
  const initialRender = useRef(true);
  const [ipAddress, setIpAddress] = useState("");
  const [country, setCountry] = useState(COUNTRY_CODE_AU_SMALL);

  const getIPAddress = async () => {
    try {
      const response = await axios.get("https://api.ipify.org?format=json");
      setIpAddress(response.data.ip);
    } catch (error) {
      console.error(referencePromoCode.errMsg.item1, error);
    }
  };

  const getCountryFromIP = async () => {
    try {
      const response = await axios.get("http://ip-api.com/json");
      const detectedCountry = response.data.countryCode.toLowerCase();

      if (detectedCountry === "au" || detectedCountry === "nz") {
        setCountry(detectedCountry);
      }
    } catch (error) {
      console.error(referencePromoCode.errMsg.item2, error);
    }
  };

  useEffect(() => {
    if (initialRender.current) {
      getCountryFromIP();
      getIPAddress();
      initialRender.current = false;
    }
  }, [ipAddress]);

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    showPassword: false,
    error: ""
  };
  const [values, setValues] = useState(initialValues);

  const initialErrors = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: ""
  };
  const [errors, setErrors] = useState(initialErrors);

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const navigate = useNavigate();

  const handleInputChange = (field, value) => {
    setValues({ ...values, [field]: value });
    validateField(field, value);
  };

  const validateField = (field, value) => {
    let error = "";
    switch (field) {
      case "firstName":
        error =
          value.trim() !== "" && value.length >= 3
            ? ""
            : referencePromoCode.errMsg.item3;
        break;
      case "lastName":
        error =
          value.trim() !== "" && value.length >= 3
            ? ""
            : referencePromoCode.errMsg.item4;
        break;
      case "email":
        if (value.length > 100) {
          error = login.errorMSG.emailLong;
        } else {
          error = EMAIL_REGEX.test(value) ? "" : login.errorMSG.enterEmail;
        }
        break;

      case "phoneNumber":
        error =
          value.trim() !== "" && NUMBER_REGEX.test(value)
            ? ""
            : referencePromoCode.errMsg.item6;
        break;
      case "password": {
        const passwordErrors = [];
        if (value.length < 8) {
          passwordErrors.push(
            <small className="mt-1 d-block">
              <FaInfoCircle /> `${referencePromoCode.errMsg.item7}`
            </small>
          );
        }
        if (!DIGIT_REGEX.test(value)) {
          passwordErrors.push(
            <small className="mt-1 d-block">
              <FaInfoCircle /> `${referencePromoCode.errMsg.item8}`
            </small>
          );
        }
        if (!UPPERCASE_REGEX.test(value)) {
          passwordErrors.push(
            <small className="mt-1 d-block">
              <FaInfoCircle /> {changeUserPass.errmsg.item3}
            </small>
          );
        }
        if (!SPECIAL_CHAR_REGEX.test(value)) {
          passwordErrors.push(
            <small className="mt-1 d-block">
              <FaInfoCircle /> `${changeUserPass.errmsg.item4}`
            </small>
          );
        }
        error =
          passwordErrors.length > 0 ? (
            passwordErrors
          ) : (
            <small className="primary-color">
              <FaCheck /> `${passwordtext.okPassword}`
            </small>
          );
        break;
      }
      default:
        break;
    }
    setErrors({ ...errors, [field]: error });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const isValidFirstName = values.firstName.length >= 3;
    const isValidLastName = values.lastName.length >= 3;
    const isValidEmail = EMAIL_REGEX.test(values.email);
    const isValidPhoneNumber =
      typeof values.phoneNumber === "string" &&
      values.phoneNumber.trim() !== "";
    const isValidPassword = PASSWORD_VALIDATION_REGEX.test(values.password);

    if (
      !isValidFirstName ||
      !isValidLastName ||
      !isValidEmail ||
      !isValidPhoneNumber ||
      !isValidPassword
    ) {
      setErrors({
        firstName: isValidFirstName
          ? ""
          : profiletexts.errorMessage.firstNameRequired,
        lastName: isValidLastName
          ? ""
          : profiletexts.errorMessage.lastNameRequired,
        email: isValidEmail ? "" : login.errorMSG.enterEmail,
        phoneNumber: isValidPhoneNumber
          ? ""
          : `${referencePromoCode.errMsg.item13}`,
        password: isValidPassword ? "" : referencePromoCode.errMsg.item14
      });
    } else {
      try {
        const userdataentry = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          primaryContactNumber: values.phoneNumber,
          password: values.password
        };
        const response = await publicAxios.post(`/register`, userdataentry);
        if (response.status === 200) {
          showToast(response.data.message, showToastType.success);
          if (window.fbq) {
            window.fbq(TRACK, metaPixel.completeRegistration);
          }
          setValues({ ...values, error: "" });
          navigate("/");
        } else {
          setErrors({
            ...errors,
            submit: referencePromoCode.errMsg.item15
          });
        }
      } catch (error) {
        console.error(referencePromoCode.errMsg.item16, error);
        setErrors({ ...errors, submit: referencePromoCode.errMsg.item17 });
      }
    }
  };
  return (
    <>
      <Headerweb />
      <main>
        <div className="sign-up-wrap conference_sign_up">
          <div className="container-wrap mt-4">
            <div className="col-row">
              <div className="left-section">
                <div className="about-content">
                  <p>
                    <i>{aboutSignUpContent.left.p1}</i>
                  </p>
                  <h3>{aboutSignUpContent.left.title}</h3>
                  <h2>{aboutSignUpContent.left.subH2}</h2>
                </div>
              </div>
              <div className="right-section">
                <div className="sign-up-form">
                  <div className="fundtap-heading">
                    <h2> {aboutSignUpContent.right.h2}</h2>
                    <p> {aboutSignUpContent.right.p1}</p>
                  </div>
                  <form id="signup_form" onSubmit={handleSubmit}>
                    <div className="input-row">
                      <div className="left-col">
                        <div className="input-group">
                          <label htmlFor="">{profiletexts.first_name}</label>
                          <input
                            type="text"
                            placeholder="Alexan"
                            name="first_name"
                            onChange={(e) =>
                              handleInputChange("firstName", e.target.value)
                            }
                            value={values.firstName}
                          />
                          {errors.firstName && (
                            <p className="error-message">
                              <small>{errors.firstName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="right-col">
                        <div className="input-group">
                          <label htmlFor="">{profiletexts.last_name}</label>
                          <input
                            type="text"
                            placeholder="Doe"
                            name="last_name"
                            onChange={(e) =>
                              handleInputChange("lastName", e.target.value)
                            }
                            value={values.lastName}
                          />
                          {errors.lastName && (
                            <p className="error-message">
                              <small>{errors.lastName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <label htmlFor="">{profiletexts.email}</label>
                        <input
                          type="email"
                          placeholder="alexandoe@example.com"
                          name="email"
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          value={values.email}
                        />
                        {errors.email && (
                          <p className="error-message">
                            <small>
                              {` ${
                                errors.email.length > 50
                                  ? Inputfieldvalidation.errorMsg.emailIsLong
                                  : errors.email
                              }`}
                            </small>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <label htmlFor="">{signup.signupBox.phoneNumber}</label>
                        <PhoneInput
                          inputProps={{
                            name: "phone_number"
                          }}
                          className="ph-with-country-code"
                          country={country}
                          onChange={(value) =>
                            handleInputChange("phoneNumber", value)
                          }
                          value={values.phoneNumber}
                          countryCodeEditable={false}
                          onlyCountries={["nz", "au"]}
                          areaCodes={{ au: ["61"], nz: ["64"] }}
                        />
                        {errors.phoneNumber && (
                          <p className="error-message">
                            <small>{errors.phoneNumber}</small>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <label htmlFor="">{login.loginBox.passwordText} </label>
                        <div className="passowrd-show">
                          <input
                            type={values.showPassword ? "text" : "password"}
                            onChange={(e) =>
                              handleInputChange("password", e.target.value)
                            }
                            value={values.password}
                            minLength={8}
                            placeholder="at least 8 characters"
                          />
                          <button
                            type="button"
                            className="password-icon"
                            onClick={handleClickShowPassword}
                          >
                            {values.showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                        {errors.password && (
                          <p className="error-message">
                            <small>{errors.password}</small>
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="input-row">
                      <div className="input-group">
                        <button type="submit" className="btn-primary">
                          {aboutSignUpContent.right.inputGroup.btnText}
                        </button>
                      </div>
                    </div>

                    {errors.submit && (
                      <p className="error-message mt-2">{errors.submit}</p>
                    )}
                  </form>
                </div>
                <div className="btm_note">
                  <small>{aboutSignUpContent.right.inputGroup.btnNote}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footerweb />
    </>
  );
};

export default ConferenceSignUp;
